angular
  .module('contabilidad.polizasexternas')
  .service(
    'ContabilidadPolizasexternasCatalogosProyectos',
    ContabilidadPolizasexternasCatalogosProyectos,
  )

ContabilidadPolizasexternasCatalogosProyectos.$inject = ['$http']

function ContabilidadPolizasexternasCatalogosProyectos ($http) {
  this.get = get

  function get () {
    return $http.get('/api/contabilidad/catalogos/proyectos')
  }
}




// WEBPACK FOOTER //
// ./src/contabilidad/polizasexternas/services/Catalogos/Proyectos.js